var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38778 6.9671C5.12909 7.33487 2.66577 10.0904 2.66406 13.3698V13.7779C4.08031 12.0718 6.17077 11.069 8.38778 11.0321V13.1844C8.38785 13.4966 8.56635 13.7814 8.84737 13.9176C9.12839 14.0538 9.46252 14.0174 9.70766 13.824L15.0365 9.6162C15.2257 9.4671 15.3362 9.2395 15.3362 8.99861C15.3362 8.75772 15.2257 8.53012 15.0365 8.38102L9.70766 4.17327C9.46252 3.97982 9.12839 3.94345 8.84737 4.07963C8.56635 4.21581 8.38785 4.50059 8.38778 4.81287V6.9671Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShares);
export default __webpack_public_path__ + "static/media/shares.1e5602ebf024fbcfa21f2dad402ba686.svg";
export { ForwardRef as ReactComponent };